// proto/v2/persona/persona.proto
//
// Personas + onboarding over WS (R14). A persona is a config-driven
// whole-workspace preset: it references a skill pack, default profile(s), a
// default nav-menu layout, and default settings. Applying a persona installs
// its skill pack into the user's catalog and writes its defaults into the
// server-synced per-user settings bag.
//
// Launch posture (GENERAL ONLY): the framework ships with a single generic
// "general" persona. Curated personas (teacher/lawyer/...) are Phase-2 content
// added by dropping a YAML — no proto or code change.
//
//   ListPersonasRequest          → the catalog (id/name/use_case/description)
//   ApplyPersonaRequest          → install pack + write defaults for the user
//   GetOnboardingStateRequest    → has the user finished/skipped onboarding
//   CompleteOnboardingRequest    → mark onboarding done (chosen persona or skip)

// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file persona/persona.proto (package lvdr.v2.persona, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file persona/persona.proto.
 */
export const file_persona_persona: GenFile = /*@__PURE__*/
  fileDesc("ChVwZXJzb25hL3BlcnNvbmEucHJvdG8SD2x2ZHIudjIucGVyc29uYSKgAQoHUGVyc29uYRIKCgJpZBgBIAEoCRIMCgRuYW1lGAIgASgJEhAKCHVzZV9jYXNlGAMgASgJEhMKC2Rlc2NyaXB0aW9uGAQgASgJEhIKCnNraWxsX3BhY2sYBSABKAkSFwoPZGVmYXVsdF9wcm9maWxlGAYgASgJEhMKC3NraWxsX2NvdW50GAcgASgFEhIKCmlzX2RlZmF1bHQYCCABKAgiFQoTTGlzdFBlcnNvbmFzUmVxdWVzdCJCChRMaXN0UGVyc29uYXNSZXNwb25zZRIqCghwZXJzb25hcxgBIAMoCzIYLmx2ZHIudjIucGVyc29uYS5QZXJzb25hIikKE0FwcGx5UGVyc29uYVJlcXVlc3QSEgoKcGVyc29uYV9pZBgBIAEoCSJXChRBcHBseVBlcnNvbmFSZXNwb25zZRISCgpwZXJzb25hX2lkGAEgASgJEhgKEHNraWxsc19pbnN0YWxsZWQYAiADKAkSEQoJbmF2X29yZGVyGAMgAygJIhsKGUdldE9uYm9hcmRpbmdTdGF0ZVJlcXVlc3QiRwoaR2V0T25ib2FyZGluZ1N0YXRlUmVzcG9uc2USEQoJY29tcGxldGVkGAEgASgIEhYKDmNob3Nlbl9wZXJzb25hGAIgASgJIkAKGUNvbXBsZXRlT25ib2FyZGluZ1JlcXVlc3QSEgoKcGVyc29uYV9pZBgBIAEoCRIPCgdza2lwcGVkGAIgASgIIkcKGkNvbXBsZXRlT25ib2FyZGluZ1Jlc3BvbnNlEhEKCWNvbXBsZXRlZBgBIAEoCBIWCg5jaG9zZW5fcGVyc29uYRgCIAEoCUIoWiZnaXRodWIuY29tL2d2czQyL2x2ZHIvcHJvdG8vdjIvcGVyc29uYWIGcHJvdG8z");

/**
 * A persona catalog entry surfaced to the onboarding wizard + settings.
 *
 * @generated from message lvdr.v2.persona.Persona
 */
export type Persona = Message<"lvdr.v2.persona.Persona"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * use_case is the short slug (e.g. "general", "teacher") mirroring the
   * profile loader's use_case field. Drives grouping/recommendation copy.
   *
   * @generated from field: string use_case = 3;
   */
  useCase: string;

  /**
   * @generated from field: string description = 4;
   */
  description: string;

  /**
   * skill_pack is the id of the SkillPack this persona installs (may be empty
   * for a do-nothing persona like "general").
   *
   * @generated from field: string skill_pack = 5;
   */
  skillPack: string;

  /**
   * default_profile is the research profile this persona selects as the user's
   * default (references an existing profile by name; empty = leave unchanged).
   *
   * @generated from field: string default_profile = 6;
   */
  defaultProfile: string;

  /**
   * skill_count is the number of skills the persona's pack installs (display
   * hint for the wizard card; 0 for general).
   *
   * @generated from field: int32 skill_count = 7;
   */
  skillCount: number;

  /**
   * is_default marks the generic fallback persona ("general").
   *
   * @generated from field: bool is_default = 8;
   */
  isDefault: boolean;
};

/**
 * Describes the message lvdr.v2.persona.Persona.
 * Use `create(PersonaSchema)` to create a new message.
 */
export const PersonaSchema: GenMessage<Persona> = /*@__PURE__*/
  messageDesc(file_persona_persona, 0);

/**
 * List the available persona catalog. Stateless global catalog.
 *
 * @generated from message lvdr.v2.persona.ListPersonasRequest
 */
export type ListPersonasRequest = Message<"lvdr.v2.persona.ListPersonasRequest"> & {
};

/**
 * Describes the message lvdr.v2.persona.ListPersonasRequest.
 * Use `create(ListPersonasRequestSchema)` to create a new message.
 */
export const ListPersonasRequestSchema: GenMessage<ListPersonasRequest> = /*@__PURE__*/
  messageDesc(file_persona_persona, 1);

/**
 * @generated from message lvdr.v2.persona.ListPersonasResponse
 */
export type ListPersonasResponse = Message<"lvdr.v2.persona.ListPersonasResponse"> & {
  /**
   * @generated from field: repeated lvdr.v2.persona.Persona personas = 1;
   */
  personas: Persona[];
};

/**
 * Describes the message lvdr.v2.persona.ListPersonasResponse.
 * Use `create(ListPersonasResponseSchema)` to create a new message.
 */
export const ListPersonasResponseSchema: GenMessage<ListPersonasResponse> = /*@__PURE__*/
  messageDesc(file_persona_persona, 2);

/**
 * Apply a persona's curated setup for the calling user: install its skill pack
 * into the user's catalog, set the default profile, write the default nav-menu
 * order + default settings into the server-synced settings bag. Idempotent —
 * re-applying the same persona is a no-op beyond re-asserting the defaults.
 *
 * @generated from message lvdr.v2.persona.ApplyPersonaRequest
 */
export type ApplyPersonaRequest = Message<"lvdr.v2.persona.ApplyPersonaRequest"> & {
  /**
   * @generated from field: string persona_id = 1;
   */
  personaId: string;
};

/**
 * Describes the message lvdr.v2.persona.ApplyPersonaRequest.
 * Use `create(ApplyPersonaRequestSchema)` to create a new message.
 */
export const ApplyPersonaRequestSchema: GenMessage<ApplyPersonaRequest> = /*@__PURE__*/
  messageDesc(file_persona_persona, 3);

/**
 * @generated from message lvdr.v2.persona.ApplyPersonaResponse
 */
export type ApplyPersonaResponse = Message<"lvdr.v2.persona.ApplyPersonaResponse"> & {
  /**
   * @generated from field: string persona_id = 1;
   */
  personaId: string;

  /**
   * skills_installed lists the skill ids enabled in the user's catalog.
   *
   * @generated from field: repeated string skills_installed = 2;
   */
  skillsInstalled: string[];

  /**
   * nav_order is the resulting per-user nav ordering written to settings.
   *
   * @generated from field: repeated string nav_order = 3;
   */
  navOrder: string[];
};

/**
 * Describes the message lvdr.v2.persona.ApplyPersonaResponse.
 * Use `create(ApplyPersonaResponseSchema)` to create a new message.
 */
export const ApplyPersonaResponseSchema: GenMessage<ApplyPersonaResponse> = /*@__PURE__*/
  messageDesc(file_persona_persona, 4);

/**
 * Onboarding completion state for the calling user. Drives whether the new-user
 * wizard auto-opens. Re-runnable: the user can re-open onboarding from settings
 * even after completing it.
 *
 * @generated from message lvdr.v2.persona.GetOnboardingStateRequest
 */
export type GetOnboardingStateRequest = Message<"lvdr.v2.persona.GetOnboardingStateRequest"> & {
};

/**
 * Describes the message lvdr.v2.persona.GetOnboardingStateRequest.
 * Use `create(GetOnboardingStateRequestSchema)` to create a new message.
 */
export const GetOnboardingStateRequestSchema: GenMessage<GetOnboardingStateRequest> = /*@__PURE__*/
  messageDesc(file_persona_persona, 5);

/**
 * @generated from message lvdr.v2.persona.GetOnboardingStateResponse
 */
export type GetOnboardingStateResponse = Message<"lvdr.v2.persona.GetOnboardingStateResponse"> & {
  /**
   * completed is true once the user has finished or explicitly skipped onboarding.
   *
   * @generated from field: bool completed = 1;
   */
  completed: boolean;

  /**
   * chosen_persona is the persona id the user picked (empty if skipped/general).
   *
   * @generated from field: string chosen_persona = 2;
   */
  chosenPersona: string;
};

/**
 * Describes the message lvdr.v2.persona.GetOnboardingStateResponse.
 * Use `create(GetOnboardingStateResponseSchema)` to create a new message.
 */
export const GetOnboardingStateResponseSchema: GenMessage<GetOnboardingStateResponse> = /*@__PURE__*/
  messageDesc(file_persona_persona, 6);

/**
 * Mark onboarding complete. persona_id empty / "general" means "skipped" — the
 * user lands in a working default workspace either way.
 *
 * @generated from message lvdr.v2.persona.CompleteOnboardingRequest
 */
export type CompleteOnboardingRequest = Message<"lvdr.v2.persona.CompleteOnboardingRequest"> & {
  /**
   * @generated from field: string persona_id = 1;
   */
  personaId: string;

  /**
   * skipped distinguishes an explicit skip from a persona selection (both set
   * completed=true, but the analytics/UX differ).
   *
   * @generated from field: bool skipped = 2;
   */
  skipped: boolean;
};

/**
 * Describes the message lvdr.v2.persona.CompleteOnboardingRequest.
 * Use `create(CompleteOnboardingRequestSchema)` to create a new message.
 */
export const CompleteOnboardingRequestSchema: GenMessage<CompleteOnboardingRequest> = /*@__PURE__*/
  messageDesc(file_persona_persona, 7);

/**
 * @generated from message lvdr.v2.persona.CompleteOnboardingResponse
 */
export type CompleteOnboardingResponse = Message<"lvdr.v2.persona.CompleteOnboardingResponse"> & {
  /**
   * @generated from field: bool completed = 1;
   */
  completed: boolean;

  /**
   * @generated from field: string chosen_persona = 2;
   */
  chosenPersona: string;
};

/**
 * Describes the message lvdr.v2.persona.CompleteOnboardingResponse.
 * Use `create(CompleteOnboardingResponseSchema)` to create a new message.
 */
export const CompleteOnboardingResponseSchema: GenMessage<CompleteOnboardingResponse> = /*@__PURE__*/
  messageDesc(file_persona_persona, 8);

